var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down-box"},[_c('span',[_vm._v("考试倒计时:")]),_c('div',{staticClass:"count-time"},[_c('span',[_vm._v(_vm._s(_vm.hour))]),_c('span',{staticClass:"ml5 mr5"},[_vm._v(":")]),_c('span',[_vm._v(_vm._s(_vm.minute))]),_c('span',{staticClass:"ml5 mr5"},[_vm._v(":")]),_c('span',[_vm._v(_vm._s(_vm.second))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }